import React from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { backendApi } from "@/api/backendApi";

export default function JobDetail() {
  const [params] = useSearchParams();
  const jobId = params.get("id");

  const { data: job } = useQuery({
    queryKey: ["job", jobId],
    queryFn: () => backendApi.db.Job.findOne({ id: jobId }),
  });

  if (!job) return <p>Loading...</p>;

  return (
    <div className="space-y-8 max-w-3xl">
      <h1 className="text-2xl font-bold text-slate-900">{job.title}</h1>

      <div className="space-y-2 text-slate-700">
        <p><strong>Location:</strong> {job.location || "N/A"}</p>
        <p><strong>Type:</strong> {job.employment_type}</p>
        <p><strong>Work:</strong> {job.work_type}</p>
      </div>

      <div>
        <h2 className="font-semibold text-slate-900 mb-2">Description</h2>
        <p className="text-slate-600 whitespace-pre-line">{job.description}</p>
      </div>
    </div>
  );
}
